import React from 'react'
import PropTypes from 'prop-types'
import { Icons } from 'components/Icons'
import CustomModal from 'ui/CustomModal'

const { RiAlertFill, MdOutlineClose } = Icons

const SignatureConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
}) => {
  if (!isOpen) return null

  return (
    <CustomModal handleCloseModal={onClose} closeModal={isOpen}>
      <div
        className='close-ico absolute top-[10px] right-[10px] cursor-pointer'
        onClick={onClose}
      >
        <MdOutlineClose className='text-3xl' />
      </div>

      <div className='modal-content p-6'>
        <div className='flex flex-wrap justify-center mb-4 alert-ico'>
          <RiAlertFill className='text-5xl text-primary' />
        </div>

        <div className='flex items-center justify-center mb-8 text-center'>
          <div className='title title-gray'>
            <h5 className='heading-5'>
              {/* Are you sure you want to save this signature? 
              <br /> */}
              <span className='text-sm font-normal text-gray-500'>
                By clicking <span className='font-bold'>Approve</span>, your
                digital signature will be automatically applied to all bills of
                sale for transactions where you are listed as the buyer or
                seller.
              </span>
              <br />
              <span className='text-sm font-normal text-gray-500'>
                Please review carefully before proceeding, as this action
                confirms your agreement to the terms of each applicable bill of
                sale.
              </span>
            </h5>
          </div>
        </div>

        <div className='flex flex-wrap justify-center w-full gap-5'>
          <button
            onClick={onClose}
            className={`
    btn btn-gray max-xl:flex-auto 
    transition-all duration-200 ease-in-out
    hover:bg-gray-200
    active:scale-95 active:translate-y-0
    disabled:opacity-50 disabled:pointer-events-none
  `}
            disabled={isLoading}
            type='button'
          >
            Cancel
          </button>

          <button
            type='button'
            onClick={onConfirm}
            className={`
    btn btn-primary max-xl:flex-auto flex items-center justify-center
    transition-all duration-200 ease-in-out
    ${
      isLoading
        ? 'opacity-70 pointer-events-none'
        : 'hover:brightness-110   active:scale-95 active:translate-y-0'
    }
  `}
          >
            {isLoading ? (
              <div className='w-5 h-5 border-2 border-white border-solid rounded-full animate-spin border-t-transparent' />
            ) : (
              'Approve & Save'
            )}
          </button>
        </div>
      </div>
    </CustomModal>
  )
}

SignatureConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
}

export default SignatureConfirmationModal
